import { getUserData } from "containers/services/data.transformers";
import { MetrixEvents } from "containers/services/events.data";
import config from "utils/globals";

const handleStatus = (type) => {
  switch (type) {
    // case "BLOCKED":
    // case "FAILED":
    //   return "error";
    case "ACTIVE":
      return "wait";
    case "DONE":
      return "finish";
    default:
      return "";
  }
};

export const stagesDataTransformer = (input, currentData) => {
  const data = [];
  config.sortArray(input?.stages, "sort")?.map((item) =>
    data.push({
      status:
        !item.status === "FAILED"
          ? currentData === item.sort && item.status === "ACTIVE"
            ? "process"
            : handleStatus(item.status)
          : "",
      title: item?.title,
      description: item?.message,
      key: item.sort,
    })
  );
  return data;
};

export const handleStagesButtonText = (data, current, failed, translate) => {
  if (current === 0) return translate("start");

  if (["finalize", "message"].includes(`${data?.current_stage}`.toLowerCase()))
    return translate("close");

  if (failed) return translate("card-page.failed-restart");

  return translate("card-page.button-continue");
};

export const handlePageTitle = (data, current, step, translate) => {
  const currentStageTitle = data?.stages?.filter(
    (item) => item.sort === current
  )?.[0]?.title;

  if (!step) return translate("card-page.create");

  return currentStageTitle;
};

export const convertOnbData = (data, key, values, current) => {
  const field = data?.stages
    .filter((item) => item.sort === current)[0]
    .fields.find((field) => field.key === key);

  const currentStage = data?.stages.filter((item) => item.sort === current)[0]
    ?.key;

  if (field) {
    field.value = values[key];
  }

  data["current_stage"] = currentStage;

  return data;
};

export const handleActionButtonMetrix = async (current, metrix, data) => {
  const user = await getUserData();
  const attrs = [{ key: "user_id", value: user?.sub }];

  switch (current) {
    case 0:
      return MetrixEvents(metrix, "ilnai", [
        ...attrs,
        {
          key: "message",
          value:
            data?.stages?.filter((item) => item.status === "FAILED")[0]
              ?.message || "",
        },
      ]);

    default:
      return MetrixEvents(metrix, "vdlrn", attrs);
  }
};
